import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid} from '../../../../shared/Models/grid';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {FabricCollectionService} from '../../../Services/fabric-collection.service';
import {ActionColumn, ActionItem, NumberColumn, TextColumn} from '../../../../shared/Models/columns';
import {FabricCollection} from '../../../Models/FabricCollection';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';

@Component({
  selector: 'app-fabric-collection',
  templateUrl: './fabric-collection.component.html',
  styleUrls: ['./fabric-collection.component.scss']
})
export class FabricCollectionComponent implements OnInit {
  @ViewChild('fabricCollectionsRowDetail', {static: false}) fabricCollectionsRowDetail: any;
  @ViewChild('dealerPriceTemp', {static: true}) dealerPriceTemp;
  @ViewChild('customerPriceTemp', {static: true}) customerPriceTemp;
  public grid: Grid;
  public fabricCollectionId: number;
  public fabricCollectionName: string;
  public disableDeleteButton = false;
  @ViewChild('deleteModal', {static: false}) deleteModal = null;

  constructor(private router: Router, private fabricCollectionService: FabricCollectionService,
              private translateService: TranslateService, private broadCastService: BroadcastService) {
  }

  ngOnInit() {

    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.fabric-collection.name',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.fabric-collection.attached_fabrics',
          prop: 'attachedFabrics',
          sortable: true,
          type: TextColumn.type,
          minWidth: 155,
          translate: true,

        },
        <TextColumn>{
          name: 'doctrine.fabric-collection.dealer_price',
          prop: 'dealerPrice',
          sortable: true,
          type: TextColumn.type,
          minWidth: 165,
          translate: true,
          valueTemplate: this.dealerPriceTemp,
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.fabric-collection.customer_price',
          prop: 'customerPrice',
          sortable: true,
          type: TextColumn.type,
          minWidth: 265,
          translate: true,
          valueTemplate: this.customerPriceTemp
        },
        <TextColumn>{
          name: 'doctrine.fabric-collection.status',
          prop: 'status',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            switch (row) {
              case true:
                return this.translateService.instant('global.active');
              case false:
                return this.translateService.instant('global.inactive');
            }
          }
        },
        <NumberColumn>{
          name: 'doctrine.fabric-collection.position',
          prop: 'position',
          sortable: true,
          type: NumberColumn.type,
          translate: true,
          maxWidth: 100,
          minWidth: 100,
          change: (e, row) => {
            const position = {position: e.target.value};
            this.fabricCollectionService.setPosition(position, row.id).subscribe((res) => {
              this.broadCastService.broadcast('refreshGrid', 'getFabricCollectionList');
            });
          },
        },
        <ActionColumn>{
          name: 'global.actions',
          width: 150,
          minWidth: 150,
          maxWidth: 150,
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-eye fa-lg',
              tooltip: 'global.view',
              onclick: row => this.router.navigateByUrl('back-office/fabric-collection/' + row.id + '/show'),
              showCallback: row => !row.isCustom,
              btnClass: 'ripple light'
            },
            <ActionItem>{
              icon: 'fa fa-pencil fa-lg',
              tooltip: 'global.edit',
              onclick: row => this.router.navigateByUrl('back-office/fabric-collection/' + row.id),
              showCallback: row => row,
              btnClass: 'ripple light ms-1'
            },
            <ActionItem>{
              icon: 'fa fa-remove fa-lg',
              tooltip: 'global.remove',
              onclick: row => {
                this.fabricCollectionId = row.id;
                this.fabricCollectionName = row.name.bold();
                this.deleteModal.show();
              },
              showCallback: row => !row.isCustom,
              btnClass: 'ripple light ms-1'
            },
          ]
        },
      ],
      service: this.fabricCollectionService,
      rememberURL: this.router.url,
      method: 'getFabricCollectionList',
      defaultSort: 'position',
      rowDetailTemplate: this.fabricCollectionsRowDetail,
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'asc',
      showButton: true,
    };

  }

  public softDelete() {
    this.disableDeleteButton = true;
    this.fabricCollectionService.softDeleteFabricCollection(this.fabricCollectionId).subscribe((res) => {
      this.broadCastService.broadcast('refreshGrid', 'getFabricCollectionList');
      this.deleteModal.hide();
      this.disableDeleteButton = true;
    });
  }
  goToArchive() {
    this.router.navigateByUrl('back-office/fabric-collection/archive');

  }
}
